import React from 'react';
export const CFIconSlash = {
    alias: 'slash',
    defaultTitle: 'Slash',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M4 12c0-1.847.635-3.542 1.688-4.897L16.897 18.31A7.948 7.948 0 0 1 12 20c-4.411 0-8-3.59-8-8Zm15.999 0a7.954 7.954 0 0 1-1.688 4.897L7.1 5.688A7.948 7.948 0 0 1 12 4c4.41 0 8 3.589 8 8ZM12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2Z' }))),
};
